import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {CommonService} from './../../_services/common.service';
import { ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2'
import {HttpRequestService} from './../../_services/http-request.service';
import { ToastrService } from 'ngx-toastr';
// import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
  cmsPageData:Array<any> = [];
  serviceData:Array<any> = [];
  categoryData:Array<any> = [];
  whatWeDoData:Array<any>=[];
  bannerData: Array<any> = [];
  carouselDirection: boolean = localStorage.getItem('_lang') == 'AR' ? true : false;

  constructor(
    public translate: TranslateService,
    private cService: CommonService,
    private activatedRoute: ActivatedRoute,
    private httpServices:HttpRequestService,
    private toastr: ToastrService,
    //config: NgbCarouselConfig
  ) {
    this.cService.activelang.subscribe((lang) => {

      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang(lang);

      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use(lang);
    });
    // config.interval = 2000;
    // config.wrap = true;
    // config.keyboard = false;
    // config.pauseOnHover = false;
  }

  ngOnInit() {

    this.activatedRoute.params.subscribe((paramData)=>{
        if (paramData.token) {
          const data = {
            lang:localStorage.getItem('_lang'),
            token: paramData.token
          };
          this.httpServices.setModule('action').post('signup_verify_action',data).subscribe((response) => {

            if (response.status=='success') {
              this.translate.get([
                'CONGRATULATION',
                'SIGNUP_VERIFICATION_SUCCESS_MSG'
              ]).subscribe((tData)=>{

                Swal.fire(tData['CONGRATULATION'], tData['SIGNUP_VERIFICATION_SUCCESS_MSG'], 'success')

              })
            }
            if (response.status=='error') {
              this.toastr.error( response.data,'Error:');
            }
          }, (error) => {
            console.log(error);
          });
        }
    });
    let data = {
      lang: localStorage.getItem('_lang')
    };
    this.httpServices.setModule('action').post('home_page',data).subscribe((response:any) => {
      if (response.status == 'success') {
        this.cmsPageData = response.data.cms_data;
        this.serviceData = response.data.service_data;
        this.categoryData = response.data.category_data;
        this.whatWeDoData = response.data.what_we_do_data;
        this.bannerData = response.data.banner_data;
        // if (localStorage.getItem("_lang") == "AR") {
        //   this.bannerData = response.data.banner_data.slice().reverse();
        // }
      } else {
        this.toastr.error( response.data,'Error:');
      }
    })

  }


  stripeHtml(htmlContent:any){

    var stripeString= htmlContent.replace(/(<([^>]+)>)/gi, "");

    return this.replaceNbsps(stripeString);
  }

  replaceNbsps(str:any) {
    return str.replace(/&nbsp;/gi, "");
  }


}
